import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { Switch as BaseSwitch } from '@headlessui/react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Switch = function Switch(_ref) {
  var size = _ref.size,
      checked = _ref.checked,
      onChange = _ref.onChange,
      srOnlyLabel = _ref.srOnlyLabel,
      disabled = _ref.disabled;
  return /*#__PURE__*/_jsxs(StyledSwitch, {
    size: size,
    checked: checked,
    onChange: onChange,
    disabled: disabled,
    children: [/*#__PURE__*/_jsx(_StyledSpan, {
      children: srOnlyLabel
    }), /*#__PURE__*/_jsx(SwitchItem, {
      size: size,
      checked: checked
    })]
  });
};
export var StyledSwitch = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(BaseSwitch, _objectSpread({}, props));
}).withConfig({
  displayName: "switch__StyledSwitch",
  componentId: "sc-1jdinod-0"
})(["", " ", " ", " ", ""], {
  "position": "relative",
  "display": "inline-flex",
  "alignItems": "center",
  "borderRadius": "9999px"
}, function (_ref2) {
  var checked = _ref2.checked;
  return checked ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(102 51 187 / var(--tw-bg-opacity))"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(133 133 145 / var(--tw-bg-opacity))"
  };
}, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 'md' : _ref3$size;

  switch (size) {
    case 'sm':
      return {
        "height": "1.25rem",
        "minHeight": "20px",
        "width": "2.5rem",
        "minWidth": "40px"
      };

    case 'md':
      return {
        "height": "1.75rem",
        "minHeight": "28px",
        "width": "3.5rem",
        "minWidth": "56px"
      };

    default:
      return {
        "height": "1.75rem",
        "minHeight": "28px",
        "width": "3.5rem",
        "minWidth": "56px"
      };
  }
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? {
    "cursor": "not-allowed",
    "opacity": "0.5"
  } : {
    "cursor": "pointer"
  };
});
export var SwitchItem = /*#__PURE__*/_styled.span.withConfig({
  displayName: "switch__SwitchItem",
  componentId: "sc-1jdinod-1"
})(["", " ", " ", ""], {
  "display": "inline-block",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms"
}, function (_ref5) {
  var _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 'md' : _ref5$size;

  switch (size) {
    case 'sm':
      return {
        "height": "1rem",
        "minHeight": "16px",
        "width": "1rem",
        "minWidth": "16px"
      };

    case 'md':
      return {
        "height": "1.25rem",
        "minHeight": "20px",
        "width": "1.25rem",
        "minWidth": "20px"
      };

    default:
      return {
        "height": "1.25rem",
        "minHeight": "20px",
        "width": "1.25rem",
        "minWidth": "20px"
      };
  }
}, function (_ref6) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? 'md' : _ref6$size,
      checked = _ref6.checked;

  switch (size) {
    case 'sm':
      return checked ? {
        "--tw-translate-x": "21px",
        "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
      } : {
        "--tw-translate-x": "3px",
        "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
      };

    case 'md':
      return checked ? {
        "--tw-translate-x": "31px",
        "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
      } : {
        "--tw-translate-x": "5px",
        "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
      };

    default:
      return checked ? {
        "--tw-translate-x": "31px",
        "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
      } : {
        "--tw-translate-x": "5px",
        "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
      };
  }
});

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "switch___StyledSpan",
  componentId: "sc-1jdinod-2"
})({
  "position": "absolute",
  "width": "1px",
  "height": "1px",
  "padding": "0",
  "margin": "-1px",
  "overflow": "hidden",
  "clip": "rect(0, 0, 0, 0)",
  "whiteSpace": "nowrap",
  "borderWidth": "0"
});